import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment-timezone';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { optionClassFormatter } from '../../../utils/formatters';
import Dropdown from '../../../components/base/Dropdown/Dropdown';
import {
  hostCommandDispatch, loadHostComponents, showHistoryPopup, loadHostProblems,
} from '../actions';
import {
  getHostMetricsByKeys,
  responseLogWithNotification,
} from '../../../utils/utils';
import {
  doorMetricKeys,
  lockMetricKeys,
  PARKING_METER_COMMAND,
  psMetricKeys,
  printerMetricKeys,
  pwrMetricKeys,
  payMetricKeys,
  bankMetricKeys, pmMetricKeys, DOOR_LOCK_STATE, DOOR_STATE, APP_STATE, POWER_SUPPLY, POWER_STATE, HOST_COMMAND_STATUS,
} from '../constants';
import {
  getBankStatus, getMetricValue, getParkingServerStatus, getPaymentBlockStatus, getPowerStatus, getPrinterStatus,
} from '../parking-meter-utils';
import notificationDecorator from '../../Notifications/notificationDecorator';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import { getParkingMetersData } from '../reducer';
import PermissionAccessWrapper from '../../../components/base/PermissionAccessWrapper';

export function ActionsFormatter({ item }) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const showHistory = () => {
    dispatch(showHistoryPopup(item.getData()));
  };
  const handleHostCommandDispatch = command => () => {
    dispatch(hostCommandDispatch({ id: item.id, command })).then(() => {
      notificationDecorator({
        title: 'Создание команды',
        message: formatMessage({ id: 'success' }),
      });
    }).catch(response => {
      responseLogWithNotification(response, 'Создание команды');
    });
  };
  return (
    <div className="actions-formatter">
      <div className="actions-formatter-buttons">
        <PermissionAccessWrapper requiredPermissions={['execute_device_reboot_command']} locked>
          <Button className="action-button replay-action">
            <Icons customIcon icon="replay" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.DEVICE_REBOOT)} />
          </Button>
        </PermissionAccessWrapper>
        <PermissionAccessWrapper requiredPermissions={['execute_unlock_upperlock_command']} locked>
          <Button className="action-button unlock-top-door-action">
            <Icons customIcon icon="unlock-top-door" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.DOORUPPER_OPEN)} />
          </Button>
        </PermissionAccessWrapper>
        <PermissionAccessWrapper requiredPermissions={['execute_unlock_lowerlock_command']} locked>
          <Button className="action-button unlock-bottom-door-action">
            <Icons customIcon icon="unlock-bottom-door" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.DOORLOWER_OPEN)} />
          </Button>
        </PermissionAccessWrapper>
      </div>
      <div className="actions-formatter-history f5" onClick={showHistory}>
        История
      </div>
    </div>
  );
}

export function MoreFormatter({ item }) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const handleOpenZabbix = () => {
    window.open(item.external_link, '_blank');
  };
  const handleHostCommandDispatch = command => () => {
    dispatch(hostCommandDispatch({ id: item.id, command })).then(() => {
      notificationDecorator({
        title: 'Создание команды',
        message: formatMessage({ id: 'success' }),
      });
    }).catch(response => {
      responseLogWithNotification(response, 'Создание команды');
    });
  };
  return (
    <TooltipWithPortal
      showByClick
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="mpf-more-actions"
      tooltipContent={(
        <div className="parking-meter-more-wrapper">
          <PermissionAccessWrapper requiredPermissions={['execute_software_reboot_command']} locked>
            <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.SOFTWARE_REBOOT)}>
              <div className="parking-meter-more-button-icon">
                <Icons width={16} height={22} customIcon icon="loop" className="button-icons" />
              </div>
              Перезапуск ПО
            </Button>
          </PermissionAccessWrapper>
          <PermissionAccessWrapper requiredPermissions={['execute_payment_reboot_command']} locked>
            <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.PAYMENT_REBOOT)}>
              <div className="parking-meter-more-button-icon">
                <Icons width={24} height={24} customIcon icon="credit-card" className="button-icons" />
              </div>
              Перезагрузка платежного контроллера
            </Button>
          </PermissionAccessWrapper>
          <PermissionAccessWrapper requiredPermissions={['execute_service_mode_command']} locked>
            <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.SERVICE_MODE)}>
              <div className="parking-meter-more-button-icon">
                <Icons width={18} height={14} customIcon icon="reorder" className="button-icons" />
              </div>
              Сервисное меню
            </Button>
          </PermissionAccessWrapper>
          <PermissionAccessWrapper requiredPermissions={['execute_test_command']} locked>
            <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.TEST)}>
              <div className="parking-meter-more-button-icon">
                <Icons width={18} height={18} customIcon icon="ballot" className="button-icons" />
              </div>
              Комплексный тест
            </Button>
          </PermissionAccessWrapper>
          <PermissionAccessWrapper requiredPermissions={['execute_hibernate_command']} locked>
            <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.HYBERNATE)}>
              <div className="parking-meter-more-button-icon">
                <Icons width={15} height={20} customIcon icon="brightness-2" className="button-icons" />
              </div>
              Перейти в режим сна
            </Button>
          </PermissionAccessWrapper>
          <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleOpenZabbix}>
            <div className="parking-meter-more-button-icon">
              <Icons width={24} height={24} customIcon icon="zabbix" className="button-icons" />
            </div>
            Перейти в ZABBIX
          </Button>
        </div>
      )}
      classNameWrapper="parking-meter-more-tooltip"
      className="parking-meter-more"
    />
  );
}

export function MobileMoreFormatter({ item }) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const anchorElement = useRef(null);
  const [isOpen, setOpen] = useState(false);
  const showHistory = () => {
    dispatch(showHistoryPopup(item.getData()));
  };
  const handleOpenZabbix = () => {
    window.open(item.external_link, '_blank');
  };
  const handleHostCommandDispatch = command => () => {
    dispatch(hostCommandDispatch({ id: item.id, command })).then(() => {
      notificationDecorator({
        title: 'Создание команды',
        message: formatMessage({ id: 'success' }),
      });
    }).catch(response => {
      responseLogWithNotification(response, 'Создание команды');
    });
  };
  return (
    <Dropdown
      usePortal
      customControl
      customOpen={isOpen}
      customHandleClose={() => { setOpen(false); }}
    >
      <Dropdown.Toggle>
        <div className={classNames('tooltip-content', 'parking-meter-more')} ref={anchorElement} onClick={() => { setOpen(true); }}>
          <Icons customIcon icon="more-vert" className="more-vert" />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className={classNames('portal-tooltip-wrapper', 'parking-meter-more-tooltip')}
        anchorElement={anchorElement}
        classNamePortal={classNames('mpf-more-actions')}
      >
        <div
          className="portal-tooltip-popup"
        >
          <div className="parking-meter-more-wrapper">
            <div className="wsh-info-title">
              Действия с паркоматом
              <Icons icon="close" customIcon className="close" onClick={() => { setOpen(false); }} />
            </div>
            <PermissionAccessWrapper requiredPermissions={['execute_software_reboot_command']} locked>
              <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.SOFTWARE_REBOOT)}>
                <div className="parking-meter-more-button-icon">
                  <Icons width={16} height={22} customIcon icon="loop" className="button-icons" />
                </div>
                Перезапуск ПО
              </Button>
            </PermissionAccessWrapper>
            <PermissionAccessWrapper requiredPermissions={['execute_payment_reboot_command']} locked>
              <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.PAYMENT_REBOOT)}>
                <div className="parking-meter-more-button-icon">
                  <Icons width={24} height={24} customIcon icon="credit-card" className="button-icons" />
                </div>
                Перезагрузка платежного контроллера
              </Button>
            </PermissionAccessWrapper>
            <PermissionAccessWrapper requiredPermissions={['execute_service_mode_command']} locked>
              <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.SERVICE_MODE)}>
                <div className="parking-meter-more-button-icon">
                  <Icons width={18} height={14} customIcon icon="reorder" className="button-icons" />
                </div>
                Сервисное меню
              </Button>
            </PermissionAccessWrapper>
            <PermissionAccessWrapper requiredPermissions={['execute_test_command']} locked>
              <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.TEST)}>
                <div className="parking-meter-more-button-icon">
                  <Icons width={18} height={18} customIcon icon="ballot" className="button-icons" />
                </div>
                Комплексный тест
              </Button>
            </PermissionAccessWrapper>
            <PermissionAccessWrapper requiredPermissions={['execute_hibernate_command']} locked>
              <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleHostCommandDispatch(PARKING_METER_COMMAND.HYBERNATE)}>
                <div className="parking-meter-more-button-icon">
                  <Icons width={15} height={20} customIcon icon="brightness-2" className="button-icons" />
                </div>
                Перейти в режим сна
              </Button>
            </PermissionAccessWrapper>
            <Button variant="link" className="w-100 parking-meter-more-button" onClick={showHistory}>
              <div className="parking-meter-more-button-icon">
                <Icons width={24} height={24} customIcon icon="history-2" className="button-icons" />
              </div>
              История команд
            </Button>
            <Button variant="link" className="w-100 parking-meter-more-button" onClick={handleOpenZabbix}>
              <div className="parking-meter-more-button-icon">
                <Icons width={24} height={24} customIcon icon="zabbix" className="button-icons" />
              </div>
              Перейти в ZABBIX
            </Button>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export function OperationStatusFormatter({ status }) {
  return (
    <div className={classNames(
      'operation-status',
      {
        error: HOST_COMMAND_STATUS.ERROR === status
          || HOST_COMMAND_STATUS.UNKNOWN === status
          || HOST_COMMAND_STATUS.NOT_SUPPORTED
          || HOST_COMMAND_STATUS.RUNTIME_ERROR
          || HOST_COMMAND_STATUS.OVERDUE,
      },
      { cancel: HOST_COMMAND_STATUS.CANCELED === status },
      { success: HOST_COMMAND_STATUS.SUCCESS === status },
      { waiting: HOST_COMMAND_STATUS.WAITING === status || HOST_COMMAND_STATUS.ACCEPTED === status },
    )}
    >
      {HOST_COMMAND_STATUS.ERROR === status ? 'Ошибка' : null}
      {HOST_COMMAND_STATUS.NOT_SUPPORTED === status ? 'Команда не поддерживается' : null}
      {HOST_COMMAND_STATUS.RUNTIME_ERROR === status ? 'Ошибка во время выполнения' : null}
      {HOST_COMMAND_STATUS.OVERDUE === status ? 'Просрочена' : null}
      {HOST_COMMAND_STATUS.CANCELED === status ? 'Отменена' : null}
      {HOST_COMMAND_STATUS.UNKNOWN === status ? 'Неизвестный статус' : null}
      {HOST_COMMAND_STATUS.WAITING === status ? 'В ожидании' : null}
      {HOST_COMMAND_STATUS.ACCEPTED === status ? 'Принята к исполнению' : null}
      {HOST_COMMAND_STATUS.SUCCESS === status ? 'Выполнена ' : null}
    </div>
  );
}
export function WorkingStateFormatter({ item }) {
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);
  const [components, setComponents] = useState(null);
  const anchorElement = useRef(null);
  const onLoadHostComponents = () => {
    dispatch(loadHostComponents(item.id)).then(comps => { setComponents(comps); setOpen(true); }).catch(responseLogWithNotification);
  };
  const metrics = getHostMetricsByKeys(item, [...bankMetricKeys, ...pwrMetricKeys, ...payMetricKeys, ...printerMetricKeys, ...psMetricKeys]);
  const { status: printerStatus, statusText: printerStatusText } = getPrinterStatus(metrics);
  const { status: psStatus, statusText: psStatusText } = getParkingServerStatus(metrics);
  const { status: bankStatus, statusText: bankStatusText } = getBankStatus(metrics);
  const { status: powerStatus, statusText: powerStatusText } = getPowerStatus(metrics);
  const { status: paymentBlockStatus, statusText: paymentBlockStatusText } = getPaymentBlockStatus(metrics);
  return (
    <div className="working-state-formatter">
      <div className="working-state-wrapper">
        <div className="working-state-block">
          <div className="working-state-name">Питание:</div>
          <div className={classNames('working-state-value', optionClassFormatter(powerStatus))}>{powerStatusText}</div>
        </div>
        <div className="working-state-block">
          <div className="working-state-name">Блок оплаты:</div>
          <div className={classNames('working-state-value', optionClassFormatter(paymentBlockStatus))}>{paymentBlockStatusText}</div>
        </div>
        {/* <div className="working-state-block"> */}
        {/*  <div className="working-state-name">Банк:</div> */}
        {/*  <div className={classNames('working-state-value', optionClassFormatter(bankStatus))}>{bankStatusText}</div> */}
        {/* </div> */}
        <div className="working-state-block">
          <div className="working-state-name">ЕГПП:</div>
          <div className={classNames('working-state-value', optionClassFormatter(psStatus))}>{psStatusText}</div>
        </div>
        <div className="working-state-block">
          <div className="working-state-name">Принтер:</div>
          <div className={classNames('working-state-value', optionClassFormatter(printerStatus))}>{printerStatusText}</div>
        </div>
      </div>
      {item.host_component_template_id
        ? (
          <div className="working-state-helper">
            <Dropdown
              usePortal
              customControl
              customOpen={isOpen}
              customHandleClose={() => { setOpen(false); }}
            >
              <Dropdown.Toggle>
                <div
                  onClick={onLoadHostComponents}
                  className={classNames('tooltip-content')}
                  ref={anchorElement}
                >
                  <Icons customIcon icon="info" className="wsh-info" />
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu
                className={classNames('portal-tooltip-wrapper wsh-portal-tooltip-wrapper')}
                anchorElement={anchorElement}
                classNamePortal="portal-tooltip wsh-portal"
                useResizeContent={false}
              >
                <div
                  className="portal-tooltip-popup"
                >
                  <div className="wsh-info-tooltip">
                    <div className="wsh-info-title">
                      Компонентная база
                      <Icons icon="close" customIcon className="close" onClick={() => { setOpen(false); }} />
                    </div>
                    <table className="wsh-info-table">
                      <tbody>
                        {components && components.values && components.values.length && components.values.map((item, key) => (
                          <tr className="wsh-info-table-row" key={key}>
                            <td className="wsh-info-table-cell wsh-key">{item.key}</td>
                            <td className="wsh-info-table-cell wsh-value">{item.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )
        : null}
    </div>
  );
}

export const doorFormatter = (doorLockState, doorState) => {
  let lockIcon = 'locked';// : 'unlock';
  let doorIcon = 'door-closed';// : 'door-closed';
  let doorColorClass = 'color-green';
  let lockColorClass = 'color-green';
  if (doorLockState === DOOR_LOCK_STATE.ERROR) {
    lockIcon = 'lock-error';
  }
  if (doorLockState === DOOR_LOCK_STATE.UNKNOWN) {
    lockIcon = 'lock-undefined';
  }
  if (doorLockState === DOOR_LOCK_STATE.LOCKED) {
    lockIcon = 'locked';
  }
  if (doorLockState === DOOR_LOCK_STATE.UNLOCKED_CLOSED) {
    lockIcon = 'unlocked-closed';
    lockColorClass = 'color-green';
  }
  if (doorLockState === DOOR_LOCK_STATE.UNLOCKED_OPENED) {
    lockIcon = 'unlocked-opened';
  }
  if (doorState === DOOR_STATE.UNKNOWN) {
    doorIcon = 'door-undefined';
  }
  if (doorState === DOOR_STATE.OPENED) {
    doorIcon = 'door-open';
  }
  if (doorState === DOOR_STATE.CLOSED) {
    doorIcon = 'door-closed';
    doorColorClass = 'color-gray';
  }
  return (
    <div className="door-icons-wrapper">
      <Icons customIcon icon={lockIcon} className={classNames('di-icon di-lock', lockColorClass)} />
      <Icons customIcon icon={doorIcon} className={classNames('di-icon di-door', doorColorClass)} />
    </div>
  );
};

export const upperDoorFormatter = (_, item) => {
  const metrics = getHostMetricsByKeys(item, [...doorMetricKeys, ...lockMetricKeys]);
  const doorUpperLockState = Number(getMetricValue(metrics)('DOOR_UPPER_LOCK_STATE'));
  const doorUpperState = Number(getMetricValue(metrics)('DOOR_UPPER_STATE'));
  return doorFormatter(doorUpperLockState, doorUpperState);
};

export const lowerDoorFormatter = (_, item) => {
  const metrics = getHostMetricsByKeys(item, [...doorMetricKeys, ...lockMetricKeys]);
  const doorLowerLockState = Number(getMetricValue(metrics)('DOOR_LOWER_LOCK_STATE'));
  const doorLowerState = Number(getMetricValue(metrics)('DOOR_LOWER_STATE'));
  return doorFormatter(doorLowerLockState, doorLowerState);
};

export const voltageFormatter = (voltage, className) => <div className={classNames('voltage-text', className)}>{voltage || 0} В</div>;
export const powerSupplyFormatter = (_, item) => {
  const metrics = getHostMetricsByKeys(item, pwrMetricKeys);
  let voltage = getMetricValue(metrics)('POWER_CHARGE_BUS', 0);
  const powerSupply = Number(getMetricValue(metrics)('POWER_SUPPLY', 0));
  voltage = voltage && voltage !== 'undefined' ? Number(voltage) : 0;
  const isSolar = powerSupply !== POWER_SUPPLY.PERMANENT;
  let icon = 'power';
  const isBoth = powerSupply === POWER_SUPPLY.BOTH;
  if (isSolar) {
    icon = 'brightness';
  }
  if (isBoth) {
    icon = 'brightness-5';
  //   return (<div className="ps-not-found" />);
  }
  return (
    <div className="power-supply-formatter">
      <Icons customIcon icon={icon} className={classNames('ps-icon', { brightness: isSolar }, { power: !isSolar }, 'color-gray')} />
      <div className="ps-voltage">{voltageFormatter(Number(voltage || 0).toFixed(1))}</div>
    </div>
  );
};
export const battery1VoltageFormatter = (_, item) => {
  const metrics = getHostMetricsByKeys(item, pwrMetricKeys);
  const powerBattery = getMetricValue(metrics)('POWER_BATTERY_1', 0);
  const powerSupply = Number(getMetricValue(metrics)('POWER_SUPPLY', 0));
  const powerBus = Number(getMetricValue(metrics)('POWER_BUS', 0));
  const powerState = Number(getMetricValue(metrics)('POWER_STATE', 0));
  const isUse = powerSupply === POWER_SUPPLY.BATTERY_1 || powerSupply === POWER_SUPPLY.BOTH;
  const voltage = isUse ? powerBus : powerBattery;
  const isLowVoltage = powerState === POWER_STATE.LOW_POWER;
  if (powerSupply === POWER_SUPPLY.PERMANENT) {
    return (<div className="ps-not-found" />);
  }
  return (
    <div className="battery-supply-formatter">
      <Icons customIcon icon={isUse ? 'load' : 'battery-charging-full'} className={classNames('ps-icon', { 'color-orange': isLowVoltage })} />
      <div className="ps-voltage">{voltageFormatter(Number(voltage || 0).toFixed(1))}</div>
    </div>
  );
};
export const battery2VoltageFormatter = (_, item) => {
  const metrics = getHostMetricsByKeys(item, pwrMetricKeys);
  const powerBattery = getMetricValue(metrics)('POWER_BATTERY_2', 0);
  const powerSupply = Number(getMetricValue(metrics)('POWER_SUPPLY', 0));
  const powerBus = Number(getMetricValue(metrics)('POWER_BUS', 0));
  const powerState = Number(getMetricValue(metrics)('POWER_STATE', 0));
  const isUse = powerSupply === POWER_SUPPLY.BATTERY_2 || powerSupply === POWER_SUPPLY.BOTH;
  const voltage = isUse ? powerBus : powerBattery;
  const isLowVoltage = powerState === POWER_STATE.LOW_POWER; // todo реализовать
  if (powerSupply === POWER_SUPPLY.PERMANENT) {
    return (<div className="ps-not-found" />);
  }
  return (
    <div className="battery-supply-formatter">
      <Icons customIcon icon={isUse ? 'load' : 'battery-charging-full'} className={classNames('ps-icon', { 'color-orange': isLowVoltage })} />
      <div className="ps-voltage">{voltageFormatter(Number(voltage || 0).toFixed(1))}</div>
    </div>
  );
};

export function StatusFormatter({ item }) {
  const { serverTimezone } = useSelector(getParkingMetersData);
  const {
    formatMessage,
  } = intlShape;
  if (!item) {
    return null;
  }
  const { status, last_ping_at } = item;
  const currentDay = moment().day();
  const lastPingAt = moment(last_ping_at);
  const lastPingAtDay = moment(last_ping_at).day();
  const metrics = getHostMetricsByKeys(item, pmMetricKeys);
  const state = Number(getMetricValue(metrics)('APP_STATE'));
  const service_mode = state === APP_STATE.SERVICE;
  return (
    <div className={classNames('status-formatter', optionClassFormatter(status))}>
      <div className="status-text">{formatMessage({ id: `parking.meter.status.${status}`, defaultMessage: formatMessage({ id: 'unknown' }) })}</div>
      <div className="last-ping-at">
        {last_ping_at ? <span className="pmh-time-wrapper">{lastPingAt.tz(serverTimezone).format(lastPingAtDay === currentDay ? 'HH:mm' : 'DD.MM.YY HH:mm')}</span> : null}
        {service_mode ? <span className="pmh-icon-wrapper"><Icons customIcon icon="construction" className="pmh-icon construction" /></span> : null}
      </div>
    </div>
  );
}

export function ProblemTable({ problems }) {
  const [scroll, setScroll] = useState(null);
  useEffect(() => {
    const a = new window.IScroll('#problems-scroll-wrapper', {
      scrollbars: true,
      mouseWheel: true,
      preventDefault: false,
      interactiveScrollbars: true,
    });
    setScroll(a);
  }, []);
  return (
    <div className="scroll-wrapper problems-scroll-wrapper" id="problems-scroll-wrapper">
      <div className="scroll">
        <table className="wsh-info-table">
          <tbody>
            {problems && problems.length ? problems.map((item, key) => (
              <tr className="wsh-info-table-row" key={key}>
                <td className="wsh-info-table-cell wsh-date">{item.time ? moment(item.time).format('DD.MM.YY HH:mm') : ''}</td>
                <td className={classNames('wsh-info-table-cell wsh-message', optionClassFormatter(item.status))}>{item.message}</td>
              </tr>
            ))
              : <tr><td colSpan={2}>Проблемы не найдены</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function StatusFormatterWithProblem({ item }) {
  const dispatch = useDispatch();
  const [isOpen, setOpen] = useState(false);
  const anchorElement = useRef(null);
  const [problems, setProblems] = useState(null);
  const onLoadHostProblems = () => {
    dispatch(loadHostProblems(item.id)).then(problems => { setProblems(problems); setOpen(true); }).catch(responseLogWithNotification);
  };
  return (
    <Dropdown
      usePortal
      customControl
      customOpen={isOpen}
      useResizeContent={false}
      customHandleClose={() => { setOpen(false); }}
    >
      <Dropdown.Toggle className="status-with-problems-toggle">
        <div
          onClick={onLoadHostProblems}
          className={classNames('status-with-problems')}
          ref={anchorElement}
        >
          <StatusFormatter item={item} />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className={classNames('portal-tooltip-wrapper wsh-portal-tooltip-wrapper')}
        anchorElement={anchorElement}
        classNamePortal="portal-tooltip wsh-portal"
        useResizeContent={false}
      >
        <div
          className="portal-tooltip-popup"
        >
          <div className="wsh-info-tooltip host-problems">
            <div className="wsh-info-title">
              Проблемы
              <Icons icon="close" customIcon className="close" onClick={() => { setOpen(false); }} />
            </div>
            {problems ? <ProblemTable problems={problems} /> : null}
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export function DateOrDateTimeFormatter({ date, onlyHour = false }) {
  const { serverTimezone } = useSelector(getParkingMetersData);
  const currentDay = moment().tz(serverTimezone).day();
  const d = moment(date).tz(serverTimezone);
  const dateDay = moment(d).day();
  if (onlyHour) {
    return d ? d.format('HH:mm') : null;
  }
  return d ? d.format(dateDay === currentDay ? 'HH:mm' : 'DD.MM.YY') : null;
}
